// the point of this script is to ensure animations run at the same speed regardless of
// the number of image and also to provide and easy adjustment mechanism (`baseSpeed`)
const baseSpeed = 10;

let resizeTimeout;
let hasRun = false;

function initialize() {
    if (hasRun) {
        return;
    }

    const galleries = document.querySelectorAll('[data-comp-name="image-gallery"]');
    let styleSheet = null;

    galleries.forEach((gallery, index) => {
        let totalWidth = 0;
        const imageElements = Array.from(gallery.children);

        if (imageElements.length < 2) return;

        // Lazily create stylesheet
        if (!styleSheet) {
            const styleEl = document.createElement('style');
            document.head.appendChild(styleEl);
            styleSheet = styleEl.sheet;
        }

        const firstImage = imageElements[0].querySelector('img');
        const firstImageSrc = firstImage ? firstImage.src : null;
        let uniqueImageCount = imageElements.length;

        // Find the first duplicate of the first image to determine the length of one "set"
        for (let i = 1; i < imageElements.length; i++) {
            const img = imageElements[i].querySelector('img');
            const imgSrc = img ? img.src : null;
            if (imgSrc === firstImageSrc && imageElements[i].offsetWidth > 0) {
                uniqueImageCount = i;
                break;
            }
        }

        // Calculate the width of one full set of unique images
        // Use a timeout to ensure images are rendered and have a width
        setTimeout(() => {
            totalWidth = 0; // Recalculate inside timeout
            for (let i = 0; i < uniqueImageCount; i++) {
                totalWidth += imageElements[i].offsetWidth;
            }
            const duration = totalWidth / baseSpeed;
            const animationName = `scroll-${index}`;
            let keyframes;

            if (gallery.classList.contains('section-image-gallery__images--bottom')) {
                // Animate from left to right
                keyframes = `@keyframes ${animationName} { 0% { transform: translateX(-${totalWidth}px); } 100% { transform: translateX(0); } }`;
            } else {
                // Animate from right to left
                keyframes = `@keyframes ${animationName} { 0% { transform: translateX(0); } 100% { transform: translateX(-${totalWidth}px); } }`;
            }

            styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
            gallery.style.animation = `${animationName} ${duration}s linear infinite`;
        }, 100);
    });
}

export default function ImageGallery() {
    // update speed on window resize
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        hasRun = false;
        resizeTimeout = setTimeout(initialize, 250);
    });

    // set initial speed
    initialize();
}
